module.exports = __webpack_public_path__ + "img/geomembranaPead2.4a2a08ed.png";